// Copyright 2026 Google LLC
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//     https://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
import { Project } from '../project-ext.js';
import { forwardToStitch } from './client.js';
// Helper to create a project instance with a client
function createProject(projectId, client) {
    return new Project(client, projectId);
}
export const downloadAssetsTool = {
    name: 'download_assets',
    description: 'Download screens and assets to a local directory',
    source: 'sdk',
    inputSchema: {
        type: 'object',
        properties: {
            projectId: { type: 'string', description: 'Project ID' },
            outputDir: { type: 'string', description: 'Output directory' }
        },
        required: ['projectId', 'outputDir']
    },
    execute: async (client, args) => {
        const { projectId, outputDir } = args;
        const project = createProject(projectId, client);
        await project.downloadAssets(outputDir);
        return {
            content: [{ type: 'text', text: `Assets downloaded to ${outputDir}` }]
        };
    }
};
export async function handleVirtualTool(name, args, ctx) {
    const dummyClient = {
        callTool: async (toolName, toolArgs) => {
            return forwardToStitch(ctx.config, 'tools/call', {
                name: toolName,
                arguments: toolArgs
            });
        }
    };
    switch (name) {
        case 'download_assets': return downloadAssetsTool.execute(dummyClient, args);
        default: throw new Error(`Unknown virtual tool: ${name}`);
    }
}
export function isVirtualTool(name) {
    return ['download_assets'].includes(name);
}
//# sourceMappingURL=virtual-tools.js.map